/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_InheritInputs */

const cs_settings_venues_inherit = /** @type {(inputs: Settings_Venues_InheritInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Převzít z kanceláře`)
};

const en_settings_venues_inherit = /** @type {(inputs: Settings_Venues_InheritInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inherit from office`)
};

/**
* | output |
* | --- |
* | "Inherit from office" |
*
* @param {Settings_Venues_InheritInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_inherit = /** @type {((inputs?: Settings_Venues_InheritInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_InheritInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_inherit(inputs)
	return cs_settings_venues_inherit(inputs)
});